
import axios from "axios";
import { store } from "store";
import { OutputBaseProps } from "utils/types/API";
import { PermissionItemProps } from ".";
import { loading, endLoading, remove } from "store/permission";

interface ApiPermissionRemoveInputProps {
    ids: number[]
}

type ApiPermissionRemoveOutputProps = OutputBaseProps<{ item: PermissionItemProps; }>

export const apiPermissionRemove = async (data: ApiPermissionRemoveInputProps) => {
    store.dispatch(loading());
    const res = (await axios.delete<ApiPermissionRemoveOutputProps>("/api/permission/remove", { data }))
        .data;
    if (res.code === 0) {
        store.dispatch(remove(data));
    }
    store.dispatch(endLoading());
    return res;
};